import React from 'react';
import {IndexLink, Link} from 'react-router';
import * as commonApi from '../../../api/common-api';
import {connect} from 'react-redux';
import Loading from 'react-loading';
import axios from 'axios';

var querystring = require('querystring');


class ProfileConnections extends React.Component {
    constructor(props) {
        super(props);
        this.state = {loading: false, connections: [], conArr: [], search: "", profileId: this.props.profileId};

        this.getConnections = this.getConnections.bind(this);
        this.generateView = this.generateView.bind(this);
    }


    componentDidMount() {
        this.setState({loading: true}, () => {
            this.getConnections();
        });


    }

    handleConnect(acc_id, event) {
        axios.get(commonApi.getAPIURL() + '?api=connectAccount&acc_id=' + acc_id)
            .then(response => {
                if (response.data.status == 1) {
                    commonApi.showAlert("Your request has been sent!")
                    //console.log(response.data);
                    this.getConnections();
                }
                return response;
            });
    }

    componentWillReceiveProps(nextProps) {
        var loading = false;
        if (nextProps.profileId != this.props.profileId) {
            loading = true;
        }
        if (loading) {
            this.setState({loading: loading, profileId: nextProps.profileId, connections: [], conArr: []}, () => {
                this.getConnections();
            });
        } else {
            this.setState({profileId: nextProps.profileId}, () => {
                this.getConnections();
            });
        }


    }

    getConnections() {
        axios.get(commonApi.getAPIURL() + '?api=getConnections&u_id=' + this.state.profileId)
            .then(response => {
                if (response.data.status == 1) {

                    this.setState({connections: response.data.data}, () => {
                        this.generateView(response.data.data);
                    });
                    //store.dispatch(getUserSuccess(response.data.data));
                }
                //console.log(response.data);
                this.setState({loading: false});
                return response;
            });
    }

    generateView(datas) {
        var conArr = [];

        for (var clm of datas) {
            var avatar = '/static/img/appimg/common-noavatar-sm.jpg';
            if (clm.image_avatar_account > 0) {
                avatar = clm.link_thumb_file;
            }
            var showConnect = "hide-el";
            if (clm.connect_cur_user == -1) {
                showConnect = "";
            }
            //console.log(school);
            conArr.push(
                <div key={"pconnection-i-" + clm.id_account} className="clm_item">

                    <div key={"pconnection-a-w-" + clm.id_account} className="avatar_wrapper">
                        <Link key={"e-c-l-a-" + clm.id_account} to={"/profile/" + clm.id_account}><img
                            src={avatar}/></Link>

                    </div>
                    <div key={"pconnection-c-w-" + clm.id_account} className="clm_content_wrapper">

                        <Link className="user_name" key={"pconnection-c-l-a-" + clm.id_account}
                              to={"/profile/" + clm.id_account}>{clm.name_account + " " + clm.last_name_account}</Link>&nbsp;
                        <p className="major_name">{clm.name_university}</p>

                    </div>
                    <div key={"pconnection-btn-w-" + clm.id_account} className="clm_btn_wrapper">
                        <a onClick={this.handleConnect.bind(this, clm.id_account)}
                           className={"icon_connect " + showConnect}><img src="/static/img/appimg/icon_invite.png"/></a>
                    </div>
                </div>
            );
        }
        this.setState({conArr: conArr});
    }

    onSearchChange(e) {
        this.setState({search: e.target.value});
        var data = [];

        for (var clm of this.state.connections) {
            var name = clm.name_account + " " + clm.last_name_account;
            if (e.target.value.trim().length > 0) {
                if (name.toLowerCase().search(e.target.value.toLowerCase()) == -1) {
                    continue;
                }
            }


            data.push(clm);
        }
        this.generateView(data);

    }


    render() {
        if (this.state.connections == undefined) {
            return (
                <div className="page_course_box profile_content_wrapper">
                    <div>
                        <div style={{color: "#545454"}}><Loading delay={0} type='spinningBubbles'
                                                                 color='rgba(84, 84, 84, 1)' width="20px"
                                                                 height="20px"/>
                        </div>
                    </div>
                </div>
            );
        }


        return (

            <div
                className={this.state.loading == false ? "page_course_box profile_content_wrapper pubpro_connection" : "hide-el"}>
                <div className="title_box">
                    <img src="/static/img/appimg/icon_connect.png"/>
                    <div className="title">
                        Connections
                    </div>
                </div>
                <div className="clm_search">

                    <input onChange={this.onSearchChange.bind(this)} className="input_search" type="text"
                           name="clm_search" placeholder="Find a connection" value={this.state.search}/>
                    <img className="icon_search" src="/static/img/appimg/icon_search.png"/>

                </div>
                <div className="clm_list">
                    {this.state.connections.length > 0 ? this.state.conArr : (
                        <div className="nocontent">No connections.</div>)}
                </div>
            </div>


        )
    }
}

export default ProfileConnections;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_connections.js
 **/